// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
class Path extends require("lib/static-shim").default(
  require("lib/utils/model").default
) {
  url() {
    let url
    const { id, resource_id, offering_id } = this.attributes
    if (resource_id) {
      // We're loading the path in a resource/offering context
      url = this.urlRoot(
        `/api/private/library/resource/${resource_id}/offering/${offering_id}/path/`
      )
    } else if (id != null) {
      url = this.urlRoot(`/api/private/path/${id}/`)
    } else {
      throw new Error("Cannot load path with given params.")
    }
    return url
  }
}

export default Path
